/* jshint esversion: 6 */
import React from 'react';
import PropTypes from 'prop-types';
import Content from 'app/components/common/Content.jsx';
import QueueScheduleComponent from 'app/components/Queue/QueueScheduleComponent.jsx';
import QueueTabs from 'app/components/Queue/QueueTabs.jsx';
import Loading from 'app/components/common/Loading.jsx';
import * as _ from 'underscore';
import ComponentWithContext from 'app/components/Routers/ComponentWithContext.jsx';

class QueueScheduleView extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            category: null
        };

        this.onCategoryFilter = this.onCategoryFilter.bind(this);
        this.addNewSchedule = this.addNewSchedule.bind(this);

    }

    onCategoryFilter(category, e) {
        if (parseInt(category.id, 10) >= 0) {
            this.setState({
                category: category.id
            });
        } else {
            this.setState({
                category: null
            });
        }

    }

    addNewSchedule(schedule, e) {
        let newSchedule = {
                's_objID': '',
                's_startTime': '',
                's_endTime': '00:00:00',
                's_days': 0,
                's_tagID': 0
            },
            social = _.clone(this.props.social),
            sched = _.clone(this.props.social.sched);

        // deep clone schedules
        social.sched = sched;

        newSchedule.s_objID = schedule.social.id;
        newSchedule.s_startTime = schedule.time;
        newSchedule.s_days = schedule.days;
        newSchedule.s_tagID = schedule.category;

        if (social.sched === undefined || !social.sched) {
            social.sched = [];
        }
        social.sched.push(newSchedule);
        social.propUpdate = true;

        this.props.updateSocial(social);

    }

    render() {

        let main = null,
            tabs = null;

        tabs = (
            <QueueTabs
                {...this.props}
                active="queue-schedule"
                social={this.props.social}
                addNewSchedule={this.addNewSchedule}
                socialUpdated={this.props.socialUpdated}
                socialErrors={this.props.socialErrors}
                onCategoryFilter={this.onCategoryFilter}
                source="schedule" />
        );

        main = (
            <QueueScheduleComponent
                {...this.props}
                social={this.props.social}
                categories={this.props.categories}
                socialUpdated={this.props.socialUpdated}
                socialErrors={this.props.socialErrors}
                category={this.state.category}
                setModal={this.props.addModal}
                updateSchedules={this.props.updateSchedules} />
        );

        return (
            <Content
                main={main}
                header={tabs}/>
        );
    }
};

QueueScheduleView.displayName = "QueueScheduleView";

QueueScheduleView.propTypes = {
    socialId: PropTypes.string,
    social: PropTypes.object,
    user: PropTypes.object
};

QueueScheduleView.defaultProps = {
    socialId: '',
    user: {},
    social: {}
};

export default ComponentWithContext(QueueScheduleView);
